import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AgGridExtensionsModule } from '../../Compliance/AgGrid/agGridExtensions.module';
import { WsAgGridWrapperModule } from '../../Compliance/AgGrid/AgGridWrapper/wsAgGridWrapper.module';
import { UILibModule } from '../../UI-Lib/UILib.module';
import {
    ActivityStatusCellRendererComponent
} from './Parcel-Filter/Activity-Status-Cell-Renderer/activityStatusCellRenderer.component';
import { ParcelFilterModalComponent } from './Parcel-Filter/parcelFilterModal.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        UILibModule,
        WsAgGridWrapperModule,
        AgGridExtensionsModule
    ],
    declarations: [
        ParcelFilterModalComponent,
        ActivityStatusCellRendererComponent
    ],
    exports: [ActivityStatusCellRendererComponent]
})
export class ActivityModule {
}
